import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { RaidTutorialResourcePackage } from "../resources/RaidTutorialResourcePackage";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class RewardHint extends Container {
    private static readonly TOLD_YA_HINT_TEXT = "Told Ya";

    private readonly tutorialResources: RaidTutorialResourcePackage;
    private readonly commonResources: CommonResourcesPackage;

    public constructor(tutorialResources: RaidTutorialResourcePackage, commonResources: CommonResourcesPackage) {
        super();
        this.tutorialResources = tutorialResources;
        this.commonResources = commonResources;
        this.build();
    }

    private build(): void {
        const rewardStrokeHint = new Sprite(this.tutorialResources.assets_tutorials_raid_tutorial_stroke_hint_png);
        rewardStrokeHint.anchor.set(0.5, 0.5);
        rewardStrokeHint.scale.set(0.85);
        this.addChild(rewardStrokeHint);
        const arrowHint = new Sprite(this.commonResources.assets_common_ui_hint_arrow_right_png);
        arrowHint.anchor.set(0.5, 0.5);
        arrowHint.scale.set(1.3, 1.3);
        arrowHint.angle = 150;
        arrowHint.position.set(rewardStrokeHint.x - rewardStrokeHint.width * 0.6, rewardStrokeHint.y + rewardStrokeHint.height * 0.5);
        this.addChild(arrowHint);
        const toldYaHint = new Text(RewardHint.TOLD_YA_HINT_TEXT, new TooltipTextStyle());
        toldYaHint.angle = -13;
        toldYaHint.anchor.set(0.5, 0.5);
        toldYaHint.position.set(arrowHint.x, arrowHint.y + arrowHint.height * 0.6);
        this.addChild(toldYaHint);
    }
}

class TooltipTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fontFamily: "Grapenuts Regular",
            fill: "#ffffff",
            fontSize: 68,
            align: "center"
        }));
    }
}
